import React from 'react';
import './SanteMentale.css';
import { Link } from 'react-router-dom';
import { FaUserFriends, FaComments } from 'react-icons/fa';
import { useLanguage } from '../i18n/LanguageContext';

const SanteMentale = () => {
  const { t } = useLanguage();
  const services = [
    {
      icon: <FaUserFriends size={40} color="#00c4ff" />,
      title: t('servicesPages.mentalHealthCoachTitle'),
      description: t('servicesPages.mentalHealthCoachBody'),
    },
    {
      icon: <FaComments size={40} color="#00c4ff" />,
      title: t('servicesPages.mentalHealthTherapyTitle'),
      description: t('servicesPages.mentalHealthTherapyBody'),
    },
  ];

  return (
    <>
      {/* Section header pleine largeur */}
      <section className="sante-header">
        <div className="sante-text">
          <h5>{t('servicesPages.label')}</h5>
          <h1>{t('servicesPages.mentalHealthTitle')}</h1>
          <p>{t('servicesPages.mentalHealthBody')}</p>
        </div>

        <div className="sante-image-wrapper">
          <div className="purple-bar"></div>
          <img
            src="/images/sante_mentale.webp"
            alt="Santé mentale"
            className="sante-main-image"
          />
        </div>
      </section>

      {/* Section cartes */}
      <section className="sante-cards">
        <h5>{t('servicesPages.label')}</h5>
        <h2>{t('servicesPages.mentalHealthCardsTitle')}</h2>
        <p>{t('servicesPages.mentalHealthCardsBody')}</p>

        <div className="sante-card-grid">
          {services.map((service, index) => (
            <div key={index} className="sante-card">
              <div className="icon">{service.icon}</div>
              <h4>{service.title}</h4>
              <p>{service.description}</p>
              <Link to="/prendre-rdv" className="rdv-button">
                {t('servicesPages.bookCta')} <span>+</span>
              </Link>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default SanteMentale;
